<template>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form" @keyup.enter.native="searchQuery">
        <a-row :gutter="10">
          <a-col :md="8" :sm="12">
            <a-form-item :label="language['epi.transformType']">
              <a-input  :placeholder="language['common.pleaseInput']+language['epi.transformType']" v-model="queryParam.itemText"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="9" :sm="24">
            <a-form-item :label="language['column.status']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                :placeholder="language['common.pleaseInput']+language['column.status']"
                v-model="queryParam.status"
              >
                <a-select-option value="1">{{language['downBoxValue.normal']}}</a-select-option>
                <a-select-option value="0">{{language['common.disable']}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24">
          <span style="float: left;" class="table-page-search-submitButtons">
            <a-button type="primary" v-has="'transform:search'" @click="searchQuery">{{language['common.searchButton']}}</a-button>
            <a-button type="primary" v-has="'transform:reset'" @click="searchReset" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
          </span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="2" :sm="24">
            <a-button style="margin-bottom: 10px" v-has="'transform:add'" type="primary" @click="handleAdd">{{language['common.insertButton']}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>
      <a-table
        ref="table"
        bordered
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
      <span slot="action" slot-scope="text, record">
        <a v-has="'transform:edit'" @click="handleEdit(record)">{{language['common.edit']}}</a>
        <a-divider type="vertical"/>
        <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
          <a v-has="'transform:delete'" >{{language['common.delete']}}</a>
        </a-popconfirm>
      </span>

      </a-table>
    </div>
  <dict-item-modal ref="modalForm" @ok="modalFormOk"></dict-item-modal> <!-- 字典数据 -->
 </a-card>
</template>

<script>
  import { get, pick } from 'lodash';
  import {filterObj} from '@/utils/util';
  import DictItemModal from './modules/DictItemModal'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import { getAction} from '@/api/manage'

  export default {
    name: "DictTransformType",
    mixins: [JeecgListMixin],
    components: {DictItemModal},
    data() {
      return {
        dictType:'',
        queryParam: {
          dictId: "",
          dictName: "",
          itemText: "",
          delFlag: "1",
          status: [],
        },
        title: "操作",
        visible: true,
        screenWidth: 800,
        model: {},
        dictId: "",
        dictCode:"epi_transformType",
        status: 1,
        labelCol: {
          xs: {span: 5},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 12},
          sm: {span: 12},
        },
        form: this.$form.createForm(this),
        transformTypeList:[],
        url: {
          list: "/sys/dictItem/listLanguage",
          delete: "/sys/dictItem/delete",
          deleteBatch: "/sys/dictItem/deleteBatch",
        },
      }
    },
    created() {
      this.initDictId();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
          {
            title: this.language['common.code'],
            align: "center",
            dataIndex: 'itemValue',
            width:400,
            validateRules: [{ required: true, message: this.language['common.pleaseInput']+this.language['common.code'] }],
          },
          {
            title: this.language['epi.transformType'],
            align: "center",
            dataIndex: 'languageText',
            width:500,
          },
          {
            title: this.language['common.action'],
            dataIndex: 'action',
            align: "center",
            scopedSlots: {customRender: 'action'},
          }
        ]
        }
      },
    },
    methods: {
      initDictId(){
        getAction("/sys/dict/getDataByCode",{dictCode:this.dictCode}).then(res=>{
          if(res.success){
            this.dictId=res.result.id;
            console.log("this.dictId:",this.dictId)
          }
        })
      },
      add(dictId) {
        this.dictId = dictId;
        this.edit({});
      },
      edit(record) {
        if (record.id) {
          this.dictId = record.id;
        }
        this.queryParam = {}
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.model.dictId = this.dictId;
        this.model.status = this.status;
        //this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'itemText', 'itemValue'))
        });
        // 当其它模块调用该模块时,调用此方法加载字典数据
        this.loadData();
      },

      getQueryParams() {
        //update--begin--autor:wangshuai-----date:20191204------for：清空总条数 teambition JT-113------
        this.ipagination.total=0;
        //update--end--autor:wangshuai-----date:20191204------for：清空总条数 teambition JT-113------
        var param = Object.assign({}, this.queryParam);
        //param.dictId = this.dictId;
        param.dictCode = this.dictCode;
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },
      dictType(){
        let that = this;
        //var dictType = that.$route.query.id;
        //alert(dictType + " == dictType");
        //var dictType2 = that.$route.params.id;
        //alert(dictType2 + " == dictType2");
      },
      // 添加字典数据
      handleAdd() {
        this.$refs.modalForm.add(this.dictId);
        this.$refs.modalForm.title = this.language['common.insertButton'];
      },
      //update--begin--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
      //增加样式方法返回值
      getRowClassname(record){
        if(record.status==0){
          return "data-rule-invalid"
        }
      }
      //update--end--autor:wangshuai-----date:20191204------for：系统管理 数据字典禁用和正常区别开，添加背景颜色 teambition JT-22------
    }
  }
</script>

<style scoped>
  @import '~@assets/less/common.less'
</style>